module.exports = __webpack_public_path__ + "img/drag.415c264c.svg";